<template>
    <v-app :style="cssProps">
        <v-content v-if="isAppDataLoaded">
            <router-view id="cont"/>
        </v-content>
    </v-app>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
        name: 'App',

        methods: {
            setFavIcon(href) {
                let link = document.querySelector("link[rel*='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.head.appendChild(link);
                }
                link.href = href;
            }
        },

        // @TODO We may not need this watch and sslsubjectdnHeader anymore. Didn't delete it yet because it requires more testing to make sure nothing will be broken.
        watch: {

            // We load the theme list names with the corresponding to the translation only after the app data is loaded.
            isAppDataLoaded(newValue, oldValue) {
                // We load the theme list only when the application is loaded
                if (newValue) {
                    this.$store.dispatch('ThemeStore/createThemeList');

                    // This code cleans up the body element for any background color set
                    // The background color is set in index.html to set the color when the user refreshes the page.
                    let bodyElement = document.querySelector('body');
                    if (typeof bodyElement !== "undefined" && bodyElement.style.backgroundColor) {
                        bodyElement.removeAttribute('style');
                    }
                }
            },

            // We update favicons and gui theme color for the specific appProperties level, when appProperties change.
            appProperties(newValue, oldValue) {
                // Update the guiTheme according to the level of the appProperty
                this.$store.dispatch('ThemeStore/updateGuiThemeColors', newValue)

                // Update drSmassPersonas according to the new appProperties
                // Update drSmassPersonas only when the property is changed or one property is null or undefined to avoid changing the image
                if ((newValue['DR_SMASS_PERSONAS'] !== oldValue['DR_SMASS_PERSONAS']) || oldValue['DR_SMASS_PERSONAS'] == null) {
                    this.$store.dispatch('ChatBotStore/updateDrSmassPersonas')
                }


                // GET the favicon from the FILE_ROOT_PATH or set the default one
                const GUI_THEME_FAVICON = newValue['GUI_THEME_FAVICON'];
                if (GUI_THEME_FAVICON == null) {
                    this.setFavIcon('static/favicon.png')
                        // favIcon.value = 'static/favicon.png'
                }
                else {
                    this.setFavIcon(this.getAppPropertyValue('FILE_ROOT_PATH') + '/logos/' + GUI_THEME_FAVICON)
                    // favIcon.value = this.getAppPropertyValue('FILE_ROOT_PATH') + '/logos/' + GUI_THEME_FAVICON;
                }
            }
        },

        computed: {
            ...mapGetters({
                sslsubjectdnHeader: 'TranslationStore/getSslsubjectdnHeader',
                isAppDataLoaded: 'TranslationStore/getIsAppDataLoaded',
                appProperties: 'TranslationStore/getAppProperties',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getSelectedLang: 'TranslationStore/getSelectedLang',
            }),

            cssProps() {

                if (this.isAppDataLoaded) {
                    let cssPropsObj = {};

                    // Load the external css file for the fonts
                    let basePath = this.getAppPropertyValue('FILE_ROOT_PATH');
                    if (basePath != null) {
                        let head  = document.getElementsByTagName('head')[0];
                        let link  = document.createElement('link');
                        link.rel  = 'stylesheet';
                        link.type = 'text/css';
                        link.href = basePath + '/fonts/fonts.css';
                        link.media = 'all';
                        head.appendChild(link);
                    }

                    if (this.getAppPropertyValue('GUI_THEME_FONT')) {
                        cssPropsObj['font-family'] = this.getAppPropertyValue('GUI_THEME_FONT');
                    }

                    return cssPropsObj;

                }
            },

        },


        created() {
            if ('-ms-scroll-limit' in document.documentElement.style
                && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
                window.addEventListener("hashchange", (event) => {
                    let currentPath = window.location.hash.slice(1);
                    if (this.$route.path !== currentPath) {
                        this.$router.push(currentPath);
                    }
                }, false);
            }
        },
}

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue